<template>
  <div>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      @close="dialogClose"
      :modal="false"
      class="updatePwDialog"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="旧密码" style="width: 100%" prop="oldPassword">
          <el-input
            class="textInput"
            v-model="ruleForm.oldPassword"
            placeholder="请输入旧密码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" style="width: 100%" prop="newPassword">
          <el-input
            class="textInput"
            v-model="ruleForm.newPassword"
            placeholder="请输入新密码"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleResetPassword">重 置</el-button>
        <el-button type="primary" @click="submitForm">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import API from "../../../../api/api_sys_manage";
import API_user from "@/api/organizeManagement/api_organizationUsre";
export default {
  name: "clglDialog",
  data() {
    let validatePassword = (rule, value, callback) => {
      // var reg1 = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/; //密码必须是8到16位、必须含有字母、数字、特殊符号
      var reg1 = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#$%^&*\(\)`_+-=\\\[\]{}:;'"<>?,./])[\da-zA-Z~!@#$%^&*\(\)`_+-=\\\[\]{}:;'"<>?,./]{8,16}$/; //密码必须是8到16位、必须含有字母、数字、特殊符号

      var reg2 = /(123|234|345|456|567|678|789|012)/; //不能有3个连续数字
      if (!reg1.test(value)) {
        // callback(new Error("设置的密码长度最少8位，最多16位，密码应该是数字、大写字母、小写字母、特殊符号组合而成"));
        callback(new Error("当前密码不符合规范请重新设置"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      ruleForm: {
        oldPassword: null,
        newPassword: null
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" }
        ],
        newPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validatePassword, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    init() {
      this.ruleForm = {
        oldPassword: "",
        newPassword: ""
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
    dialogClose() {},
    async submitForm() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          let res = await API.changePassword(this.ruleForm);
          if (res.code == 200 || res.code == 0) {
            this.$message.success(res.msg || "修改成功");
            //跳转首页
            this.$router.push({ path: "/login" });
          } else {
            this.$message.warning(res.msg || "修改密码失败");
          }
        }
      });
    },
    async handleResetPassword() {
      this.$confirm("此操作将重置密码，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let id = JSON.parse(
            localStorage.getItem(sys_token_prefix + "user_info")
          ).user.id;
          let res = await API_user.usermanageResetPassword({ userId: id });
          if (res.code == 200 || res.code == 0) {
            this.$message.success(res.msg || "重置密码成功");
            //跳转首页
            this.$router.push({ path: "/login" });
          } else {
            this.$message.warning(res.msg || "重置密码失败");
          }
        })
        .catch(() => {});
    }
  }
};
</script>
<style scoped lang="less">
.updatePwDialog {
}
/deep/ .el-dialog__header {
  text-align: center;
  background: rgb(0, 149, 91);
}
/deep/ .el-dialog__title {
  color: #fff !important;
}
/deep/ .el-input {
  width: 80% !important;
  height: 40px !important;
  float: left;
  .el-input__inner {
    height: 40px !important;
  }
}
/deep/ .el-dialog__footer {
  text-align: center;
}
/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/sys_common/sys_header_banner/sys_user_updatePw.vue